import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CounterState {
  value: number
  history: number[]
}

const initialState: CounterState = {
  value: 0,
  history: [],
}

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      state.history.push(state.value)
      state.value += 1
    },
    decrement: (state) => {
      state.history.push(state.value)
      state.value -= 1
    },
    reset: (state) => {
      state.history.push(state.value)
      state.value = 0
    },
    setValue: (state, action: PayloadAction<number>) => {
      state.history.push(state.value)
      state.value = action.payload
    },
  },
})

export const { increment, decrement, reset, setValue } = counterSlice.actions
export default counterSlice.reducer
